import { ColumnData as CD } from 'ui/tableHeader';

export enum AUTH_TYPES {
  NO_AUTH = 'NoAuth',
  BASIC = 'Basic',
  OAUTH_2 = 'OAuth2',
}

export interface EventDetails {
  text: string;
  events: Record<string, string>;
  requiredFeatureFlags: string[];
  requiredFeatureFlagsByEvent?: Record<string, string[]>;
  /** If true, only one flag from `requiredFeatureFlags` is needed to view event details.
   * If false, default behavior: all flags from `requiredFeatureFlags` are needed. */
  requireOnlyOneFlag?: boolean;
}

export type SystemWebhookFormState = {
  endpoint: string;
  authType: AUTH_TYPES;
  authToken: string;
  enabled: 'disabled' | 'enabled';
  enabledEvents: Record<string, boolean>;
  headers: { key: string; value: string }[];
  rateLimitPerSecond: number | null;
  excludeListUpdates: boolean;
};

export type WebhookParamProps = {
  /** Id unique to webhook */
  id: number;
  /** Id of project the webhook belongs to */
  projectId: number;
  /** Endpoint of webhook, must be a valid URL */
  endpoint: string;
  /** Whether or not the webhook is enabled */
  enabled: boolean;
  /** Authenticiation type */
  authType: AUTH_TYPES;
  /** Authentication token, only needed when authType is Basic or OAuth2 */
  authToken?: string;
  /**
   * Object mapping trigger events to whether or not they are enabled
   * triggerEvents is essentially a mapped representation of enabled events for quicker lookup
   */
  triggerEvents?: Record<string, any>;
  /** List of enabled trigger events */
  enabledEvents: any[];
  /** True if blastSendEnabled if the blastSend event for email is enabled */
  blastSendEnabled?: boolean;
  /** True if triggeredSend event for email is enabled */
  triggeredSendEnabled?: boolean;
  /** List of custom HTTP headers */
  headers?: any[];
  rateLimitPerSecond?: number;
  /**
   * If true, system events related to List Updates (users added to list, removed from list)
   * will not trigger the webhook. This functionality is gated by the SystemWebhookAdvancedFiltering FF.
   */
  excludeListUpdates: boolean;
};

export type SystemWebhookReducerState = {
  integrations: {
    systemWebhooks: {
      errors: string[];
      initialFetchMade: boolean;
      isFetching: boolean;
      systemWebhooksList: WebhookParamProps[];
    };
    [key: string]: any;
  };
};

export type WebhooksTableColumnData = CD & {
  RowCell: ({ row }: { row: WebhookParamProps & { eventCount: number } }) => React.ReactElement;
};

export type SystemWebhooksActionButtonProps = {
  openDeleteModal: (id: WebhookParamProps['id']) => void;
  webhook: WebhookParamProps;
};
